import { render } from "./Ydxx.vue?vue&type=template&id=74803a71"
import script from "./Ydxx.vue?vue&type=script&lang=js"
export * from "./Ydxx.vue?vue&type=script&lang=js"

import "./Ydxx.vue?vue&type=style&index=0&id=74803a71&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__